import { observer } from "mobx-react";
import { Grid, makeStyles } from '@material-ui/core';
import BorrowerInformation from "libs/feature-loans/src/loanSubmission/components/borrowerInformation";
import { Button, Paper } from "@roc/ui";
import { useHistory } from "react-router";
import { useRoutes } from "@roc/client-portal-shared/hooks";
import { useEffect } from "react";
import { Alert, AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(4),
  },
}));

export const EditLoanBorrowers = observer(props => {
  const { store, refreshLoan } = props;
  const { editLoansStore } = store;
  const classes = useStyles();
  const { push } = useHistory();
  const { loanRoutesConfig } = useRoutes();

  useEffect(() => {
    editLoansStore.loadStore(store.loanDetails);

    return () => {
      store.reset();
    };
  }, []);

  return (
    <Paper className={classes.container}>
      <BorrowerInformation store={editLoansStore} />
      <Grid container direction='row' justifyContent='flex-end' spacing={2}>
        <Grid item>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => {
              editLoansStore.updateLoanBorrowers(() => {
                push(
                  loanRoutesConfig.loans(store.loanDetails?.loanId).children
                    .dashboard.url
                )
                editLoansStore.reset();
                refreshLoan();
              });
            }}
            testId="saveLoanBorrowers"
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
});